import { Link } from 'react-router-dom';

const ErrorAccessDenied = () => {
  return (
    <div className="d-flex flex-column flex-center text-center p-10">
      {/* begin::Logo */}
      <h1 className="fw-bold fs-2qx text-gray-800 mb-7">Access Denied</h1>
      {/* end::Logo */}
      {/* begin::Message */}
      <div className="fw-semibold fs-3 text-muted mb-15">You don’t have permission to access this page.</div>
      {/* end::Message */}
      {/* begin::Action */}
      <div className="text-center">
        <Link to="/">
          <button className="btn btn-lg btn-primary fw-bold">Go to Home Page</button>
        </Link>
      </div>
      {/* end::Action*/}
    </div>
  );
};

export default ErrorAccessDenied;
